import React, { Component } from "react";
import * as THREE from "three";

class PlayerBackground extends Component {
  constructor(props, context) {
    super(props, context);

    this.duration = 1;
    this.fps = 60;

    this.state = {
      progress: 0,

      spherePosition: new THREE.Vector3(0, 0, 0),
      sphereRotation: new THREE.Euler(0, 0, 0),
      sphereScale: new THREE.Vector3(-1, 1, 1),

      previous: "",
      intervalId: null
    };

    this.onLoad = this.onLoad.bind(this);
    this.onError = this.onError.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.url != nextProps.url) {
      this.setState({
        progress: 0
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    this.mounted = false;
  }

  onError(err) {
    this.props.onImageError(err);
  }

  onLoad() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
    if (this.mounted) {
      this.setState({
        progress: 0,
        intervalId: setInterval(this.updateProgress, 1000 / this.fps)
      });
      this.props.onImageLoad();
    }
  }

  updateProgress() {
    let progress = this.state.progress + 1 / (this.duration * this.fps);
    if (progress >= 1) {
      progress = 1;
      clearInterval(this.state.intervalId);
      this.setState({
        previous: this.props.url,
        intervalId: null
      });
      if (this.props.onComplete) {
        this.props.onComplete();
      }
    }
    this.setState({
      progress
    });
  }

  render() {
    const alpha = Math.sin(this.state.progress * Math.PI * 0.5);
    const opacity = alpha;
    const startPosition = new THREE.Vector3(0, 0, 0).lerpVectors(
      this.props.direction.clone(),
      new THREE.Vector3(0, 0, 0),
      alpha
    );
    const endPosition = new THREE.Vector3(0, 0, 0).lerpVectors(
      new THREE.Vector3(0, 0, 0),
      this.props.direction
        .clone()
        .negate()
        .multiplyScalar(10),
      alpha
    );
    return (
      <group>
        <object3D>
          <mesh
            position={this.state.spherePosition}
            rotation={this.state.sphereRotation}
            scale={this.state.sphereScale}
          >
            <sphereGeometry radius={100} widthSegments={4} heightSegments={2} />
            <meshBasicMaterial side={THREE.FrontSide} />
          </mesh>
        </object3D>
        <object3D visible={this.state.previous !== ""}>
          <mesh
            position={endPosition}
            rotation={this.state.sphereRotation}
            scale={this.state.sphereScale}
          >
            <sphereGeometry
              radius={10}
              widthSegments={128}
              heightSegments={128}
            />
            <meshBasicMaterial side={THREE.FrontSide}>
              <texture crossOrigin="anonymous" url={this.state.previous} />
            </meshBasicMaterial>
          </mesh>
        </object3D>
        <object3D visible={this.props.url !== ""}>
          <mesh
            position={startPosition}
            rotation={this.state.sphereRotation}
            scale={this.state.sphereScale}
          >
            <sphereGeometry
              radius={1}
              widthSegments={128}
              heightSegments={128}
            />
            <meshBasicMaterial
              side={THREE.FrontSide}
              transparent
              opacity={opacity}
            >
              <texture
                crossOrigin="anonymous"
                url={this.props.url}
                onLoad={this.onLoad}
                onError={this.onError}
              />
            </meshBasicMaterial>
          </mesh>
        </object3D>
      </group>
    );
  }
}

export default PlayerBackground;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerBackground/PlayerBackground.js